export default __webpack_public_path__ + "static/media/riult.6764fca3.jpg";